import { useSettings } from "../context/SettingsContext";
import RichText from "./RichText";

export default function About() {
  const { settings } = useSettings();
  const has = (v) => typeof v === "string" && v.trim().length > 0;
  if (!has(settings.about_eyebrow) && !has(settings.about_title_a) && !has(settings.about_title_b) && !has(settings.about_text)) {
    return null;
  }
  return (
    <section
      id="chi-siamo"
      data-testid="about-section"
      className="px-6 sm:px-12 py-24 sm:py-32 bg-[color:var(--tr-bg-2)]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-4">
          {has(settings.about_eyebrow) && (
            <p className="label-eyebrow" data-testid="about-eyebrow" style={{ color: "#5C5A56" }}>
              {settings.about_eyebrow}
            </p>
          )}
        </div>
        <div className="col-span-12 md:col-span-8">
          {(has(settings.about_title_a) || has(settings.about_title_b)) && (
            <h2
              data-testid="about-title"
              className="font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]"
              style={{ color: "#1A1918" }}
            >
              {settings.about_title_a}
              {has(settings.about_title_a) && has(settings.about_title_b) && <br />}
              {has(settings.about_title_b) && (
                <span className="italic" style={{ color: "#5C5A56" }}>
                  {settings.about_title_b}
                </span>
              )}
            </h2>
          )}
          {has(settings.about_text) && (
            <RichText
              value={settings.about_text}
              className="font-body text-lg leading-relaxed mt-10 max-w-2xl"
              style={{ color: "#1A1918" }}
            />
          )}
        </div>
      </div>
    </section>
  );
}
